import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const imgSocial = {
  paddingRight: "10px",
  height: "15px",
  width: "9px",
  objectFit: "contain",
};
const PhoneLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  paddingRigth: "5px",
  marginRigth: "5px",
  lineHeight: "0",
};

export default function Facebook(facebook) {
  return (
    <>
      <a href={`${facebook.facebook}`}
        style={PhoneLink}
      >
        <img style={imgSocial} src={`https://files.myclientisrich.com/signatures_mcir/v2/icons/fb.png`} alt="logo" width="9px" height="15px"></img>
      </a>
      <br />
    </>
  );
}
